module.exports = __webpack_public_path__ + "static/index/img/baikal-907.357aea25.jpg";